import Container from '@/app/components/Container';
import { Consignor } from '@prisma/client';
import React from 'react';
import { DataTable } from './DataTable';
import { columns } from './columns';
import QueryClientProvider from '@/app/QueryClientProvider';
import { AugmentedConsignor } from '@/app/consignors/columns';

interface Props {
  consignors: AugmentedConsignor[];
}

const AdminHomeConsignorsTab = ({ consignors }: Props) => {
  return (
    <QueryClientProvider>
      <Container className="mt-5 mx-0 w-full">
        <DataTable
          data={consignors}
          columns={columns}
        />
      </Container>
    </QueryClientProvider>
  );
}

export default AdminHomeConsignorsTab
